import { selector } from 'recoil';

import { exportingFileNameDocumentsCenter } from './atom';

export const updateExportingFileNameDocumentsCenter = selector({
  key: 'updateExportingFileNameDocumentsCenter',
  set: ({ set }, newValue) => {
    const isExporting = newValue as string;
    return set(exportingFileNameDocumentsCenter, isExporting);
  },
  get: ({ get }) => {
    const item = get(exportingFileNameDocumentsCenter);
    return item;
  },
});
